import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as CalendarIcon } from '../../img/calendaricon.svg'
import { ReactComponent as VerticalLine } from '../../img/verticalline.svg'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; // Import styles for datepicker
import { registerLocale } from "react-datepicker";
import id from "date-fns/locale/id"; // Import Indonesian locale
import { instance2 } from "../../utils/axiosInstance";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/components/shadcn/dialog";

// Register the Indonesian locale for react-datepicker
registerLocale("id", id);

export default function InputData3() {
  const [formData, setFormData] = useState({
    category_id: "",
    uoq_id:"",
    name: "",
    multiple_qty: "1",
    frequency_id:"",
    buffer:"0",
    description:"",
  });

  const handleDateChange = (date) => {
    setFormData((prev) => ({
      ...prev,
      tanggal: date, // Update the date in the formData
    }));
  };

  const storedUserId = localStorage.getItem("userAuthentication");
  const [isPopupVisible, setIsPopupVisible] = useState(false)
  const [isPopupFailedVisible, setIsPopupFailedVisible] = useState(false)
  const [newCategory, setNewCategory] = useState("")
    const [newCategoryDescription, setNewCategoryDescription] = useState("");

  const navigate = useNavigate();
const handleSubmitNewCategory = async () => {
  if (!newCategory.trim()) return;

  try {
    await instance2.post("/ingredient_category_master", {
  name: newCategory,
  description: newCategoryDescription,
      admin_id: storedUserId
    });

    setNewCategory("");
    setIsPopupVisible(false);

    // ✅ Refetch categories after successful addition
    fetchIngredients();
  } catch (err) {
    console.error("Failed to add category:", err);
    setIsPopupFailedVisible(true)
  }
};


  const [selectedIngredientsId, setSelectedIngredientsId] = useState(null); // Track the selected ingredient
  const [ingredients, setIngredients] = useState([]); // Categories of ingredients
  const [frequency, setFrequency] = useState([]); // Ingredient names
  const [ingredientsName, setIngredientsName] = useState([]); // Ingredient names
  const [location, setLocation] = useState([]); // Storage locations
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior
  
    // Prepare data to send, ensuring necessary conversions
    const dataToSend = {
      ...formData,
      category_id: 1,//parseInt(formData.category_id, 10), // Convert 'kategori' to an integer
      uoq_id: parseInt(formData.uoq_id, 10), // Convert 'uoq_id' to an integer
    };
  
    try {
      // Use instance2 for the API call
      const response = await instance2.post("ingredient_master", dataToSend);
  
      // Handle successful response
      console.log("Success:", response.data);
      //alert("Data berhasil disimpan!");
      navigate(-1);
    } catch (error) {
      // Handle errors
      console.error("Error:", error.response?.data || error.message);
      //alert(error.response?.data?.message || "An error occurred while submitting the data.");
    setIsPopupFailedVisible(true)
    }
  };
  
  

  // Handle change for form fields
  const handleChange = (e) => {
    const { name, value } = e.target;

  if (name === "category_id" && value === "add_new") {
    // Open the dialog to add new category
    setIsPopupVisible(true);
    return; // Don't update formData yet
  }
  
    setFormData((prev) => ({
      ...prev,
      [name]: value, // Dynamically update formData with the selected field
    }));

    // Update selectedIngredientsId for "kategori" dropdown
    // if (name === "kategori") {
    //   setSelectedIngredientsId(value); // Store the selected category ID
    // }
  };

  // Fetch ingredient categories
const fetchIngredients = async () => {
  try {
    const response = await instance2.get("ingredient_category_master");

    const ingredientsData = response.data;

    const formattedIngredients = ingredientsData.map((ingredient) => ({
      id: ingredient.id,
      name: ingredient.name,
    }));

    setIngredients(formattedIngredients);

    if (formattedIngredients.length > 0) {
      setFormData((prev) => ({
        ...prev,
        kategori: formattedIngredients[0].id,
      }));
      setSelectedIngredientsId(formattedIngredients[0].id);
    }
  } catch (err) {
    console.error("Failed to fetch ingredients", err);
    setError(err.response?.data?.message || "Failed to fetch ingredient categories");
  } finally {
    setLoading(false);
  }
};
useEffect(() => {
  fetchIngredients();
}, []);

  

  // Fetch ingredient names based on selected category
  useEffect(() => {
    if (!selectedIngredientsId) return;
  
    const fetchIngredientsName = async () => {
      try {
        const response = await instance2.get(`ingredient_master/${selectedIngredientsId}`); // Use instance2 for the API call
  
        const ingredientsNameData = response.data; // Access data directly from Axios response
  
        setIngredientsName(
          ingredientsNameData.map((ingredient) => ({
            id: ingredient.id,
            name: ingredient.name,
          }))
        );
      } catch (err) {
        console.error("Failed to fetch ingredient names", err);
        setError(err.response?.data?.message || "Failed to fetch ingredient names");
      } finally {
        setLoading(false);
      }
    };
  
    fetchIngredientsName();
  }, [selectedIngredientsId]);
  

  // Fetch storage locations
  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await instance2.get("ingredient_uoq_master"); // Use instance2 for the API call
  
        const locationData = response.data; // Access the data property from Axios response
  
        setLocation(
          locationData.map((loc) => ({
            id: loc.id,
            name: loc.name,
            code: loc.code,
          }))
        );
      } catch (err) {
        console.error("Failed to fetch locations", err);
        setError(err.response?.data?.message || "Failed to fetch storage locations");
      } finally {
        setLoading(false);
      }
    };
  
    fetchLocation();
  }, []);
  
  

  // Fetch storage locations
  useEffect(() => {
    const fetchFrequency = async () => {
      try {
        const response = await instance2.get("frequency_master"); // Use instance2 for the API call
  
        const frequencyData = response.data; // Access data directly from Axios response
  
        setFrequency(
          frequencyData.map((freq) => ({
            id: freq.id,
            name: freq.name,
          }))
        );
      } catch (err) {
        console.error("Failed to fetch frequency", err);
        setError(err.response?.data?.message || "Failed to fetch frequency");
      } finally {
        setLoading(false);
      }
    };
  
    fetchFrequency();
  }, []);
  

// Custom Input with className
const CustomInput = React.forwardRef(({ value, onClick, className }, ref) => (
  <button
    type="button"
    onClick={onClick}
    ref={ref}
  >
    {value || "Pilih tanggal"}
  </button>
));

const combinedValue = `${formData.textInput} - ${formData.koperasi}`;
useEffect(() => {
  if (frequency.length > 0 && !formData.frequency_id) {
    setFormData((prev) => ({ ...prev, frequency_id: 1 }));
  }
}, [frequency]);

  return (
    <div className="flex flex-col items-center justify-center p-4 sm:p-10">
  <div className="flex flex-col sm:flex-row justify-between lg:gap-10 w-full text-xs">
    {loading ? (
      <p>Loading...</p>
    ) : error ? (
      <p className="text-red-500">{error}</p>
    ) : (
      <>
        {/* LEFT SECTION */}
        <div className="w-full sm:w-1/2">
          {/* <div className="flex flex-col sm:flex-row my-4 items-start sm:items-center gap-2">
            <label className="block text-gray-700 mb-2 w-full sm:w-1/3">
              Kategori Bahan
            </label>
            <>
      <select
        name="category_id"
        value={formData.category_id}
        onChange={handleChange}
        className="w-full px-3 border-none rounded-full bg-white text-xs py-4"
        required
      >
        <option value="" disabled>
          Pilih kategori bahan
        </option>
        {ingredients.map((ingredient) => (
          <option key={ingredient.id} value={ingredient.id}>
            {ingredient.name}
          </option>
        ))}
        <option value="add_new" className="text-merah-no">+ TAMBAH KATEGORI BAHAN BAKU</option>
      </select>

     <Dialog open={isPopupVisible} onOpenChange={setIsPopupVisible}>
       <DialogContent onInteractOutside={(e) => e.preventDefault()}>
         <DialogHeader>
           <DialogTitle>Tambah Kategori Baru</DialogTitle>
         </DialogHeader>
     

         <input
           type="text"
           placeholder="Nama kategori"
           value={newCategory}
           onChange={(e) => setNewCategory(e.target.value)}
           className="w-full border rounded px-2 py-1 mt-2 uppercase"
         />
     

         <textarea
           placeholder="Deskripsi kategori (opsional)"
           value={newCategoryDescription}
           onChange={(e) => setNewCategoryDescription(e.target.value)}
           className="w-full border rounded px-2 py-1 mt-2 text-sm"
           rows={3}
         />
     
         <DialogFooter className="sm:justify-end">
           <button
             className="mt-2 px-4 py-2 bg-merah-no text-white rounded"
             onClick={handleSubmitNewCategory}
           >
             Simpan
           </button>
           <DialogClose asChild>
             <button className="ml-2 px-4 py-2 text-sm text-gray-600">
               Batal
             </button>
           </DialogClose>
         </DialogFooter>
       </DialogContent>
     </Dialog>
    </>
          </div> */}
          <div className="flex flex-col sm:flex-row my-4 items-start sm:items-center gap-2">
            <label className="block text-gray-700 mb-2 w-full sm:w-1/3">
              Nama Bahan Baku
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Masukkan nama bahan baku"
              className="w-full px-3 border-none rounded-full bg-white text-xs py-4"
            />
          </div>
                    {/* <div className="flex flex-col sm:flex-row my-4 items-start sm:items-center gap-2 w-full">
            <label className="block text-gray-700 mb-2 w-full sm:w-1/3">
              Jumlah Kelipatan
            </label>
            <input
              type="number"
              name="multiple_qty"
              value={formData.multiple_qty}
              onChange={handleChange}
              placeholder="Masukkan kelipatan pemesanan"
              className="w-full px-3 border-none rounded-full bg-white text-xs py-4"
            />
          </div> */}
          <div className="flex flex-col sm:flex-row my-4 items-start sm:items-center gap-2 w-full">
            <label className="block text-gray-700 mb-2 w-full sm:w-1/3">
              Frekuensi
            </label>
            <select
              name="frequency_id"
              value={formData.frequency_id}
              onChange={handleChange}
              className="w-full px-3 border-none rounded-full bg-white text-xs py-4"
              required
            >
              <option value="" disabled>
                Pilih frekuensi pengiriman
              </option>
              {frequency.map((freq) => (
                <option key={freq.id} value={freq.id}>
                  {freq.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        

        {/* RIGHT SECTION */}
        <div className="w-full sm:w-1/2 px-0 sm:px-4">
          {/* Dropdown Section */}
          <div className="flex flex-col sm:flex-row my-4 items-start sm:items-center gap-2 w-full">
            <label className="block text-gray-700 mb-2 w-full sm:w-1/3">
              Unit
            </label>
            <select
              name="uoq_id"
              value={formData.uoq_id}
              onChange={handleChange}
              className="w-full px-3 border-none rounded-full bg-white text-xs py-4"
              required
            >
              <option value="" disabled>
                Pilih Unit
              </option>
              {location.map((loc) => (
                <option key={loc.id} value={loc.id}>
                  {loc.name}
                </option>
              ))}
            </select>
          </div>

          <div className="flex flex-col sm:flex-row my-4 items-start sm:items-center gap-2 w-full">
            <label className="block text-gray-700 mb-2 w-full sm:w-1/3">
              Buffer
            </label>
            <input
              type="number"
              name="buffer"
              value={formData.buffer}
              onChange={handleChange}
              placeholder="Masukkan jumlah cadangan stock"
              className="w-full px-3 border-none rounded-full bg-white text-xs py-4"
            />
          </div>
        </div>
      </>
    )}
  </div>
  <div className="flex flex-col gap-2 w-full">
    <label className="block text-gray-700 mb-2 text-xs">Catatan</label>
    <textarea
      type="description"
      name="description"
      value={formData.description}
      onChange={handleChange}
      placeholder="Masukkan catatan"
      className="w-full px-3 border-none rounded-[30px] bg-white text-xs py-4 h-[150px]"
    />
  </div>
  <div className="flex flex-row gap-8 w-full items-center justify-center">
  <button
    className="bg-merah-no p-4 text-white rounded-[20px] hover:bg-merah-hover mt-4"
    onClick={() => {window.history.back()}}
  >
    Kembali
  </button>
  <button
    className="bg-merah-no p-4 text-white rounded-[20px] hover:bg-merah-hover mt-4"
    onClick={handleSubmit}
  >
    Simpan
  </button>
</div>

<>
      <Dialog open={isPopupFailedVisible} onOpenChange={setIsPopupFailedVisible}>
        <DialogContent >
          <DialogHeader>
            <DialogTitle>Pemberitahuan</DialogTitle>
          </DialogHeader>
          <div>Gagal mengirim data</div>
            <DialogClose asChild>
              <button className="ml-2 px-4 py-2 text-sm text-gray-600">
                Keluar
              </button>
            </DialogClose>
        </DialogContent>
      </Dialog>
    </>
</div>

  );
}
